module.exports = __webpack_public_path__ + "32dc634fdebd7c4c523ae3107d187dc8.svg";